// utils/tableConstants.js
export const PERMANENT_COLUMNS = [
    'studentName',
    'courseName',
    'placedBy',
    'companyName',
    'branchDepartment',
    'package',
    'companyLocation',
    'placementDate',
    'reviewStatus',
];

export const ALL_COLUMNS = [
    { key: 'studentName', label: 'Student Name' },
    { key: 'branchDepartment', label: 'Branch / Department' },
    { key: 'courseName', label: 'Course Name' },
    { key: 'placementDate', label: 'Placed Date' },
    { key: 'placedBy', label: 'Placed By' },
    { key: 'package', label: 'Package' },
    { key: 'companyName', label: 'Company Name' },
    { key: 'companyLocation', label: 'Company Location' },
    { key: 'reviewStatus', label: 'Review Status' },
    { key: 'jobRole', label: 'Role' },
    { key: 'studentContactNumber', label: 'Contact Number' },
    { key: 'ProgressStatus', label: 'Course Status' },
    { key: 'staffId1', label: 'Staff ID 1' },
    { key: 'staffName1', label: 'Staff Name 1' },
    { key: 'studentId', label: 'Student ID' },
    { key: 'email_Id', label: 'Email' },
    { key: 'educationQualification', label: 'Education Qualification' },
    { key: 'clgName', label: 'College Name' },
    { key: 'placementneeded', label: 'Placement Needed' },
    { key: 'batch', label: 'Batch' },
    { key: 'learningMode', label: 'Learning Mode' },
    { key: 'courseType', label: 'Course Type' },
    { key: 'syllabusCovered', label: 'Syllabus Covered' },
    { key: 'staffId2', label: 'Staff ID 2' },
    { key: 'staffName2', label: 'Staff Name 2' },
    { key: 'staffId3', label: 'Staff ID 3' },
    { key: 'staffName3', label: 'Staff Name 3' },
    { key: 'noOfProjects', label: 'No Of Projects' },
    { key: 'projectTitle1', label: 'Project 1 Title' },
    { key: 'project1Status', label: 'Project 1 Status' },
    { key: 'projectTitle2', label: 'Project 2 Title' },
    { key: 'project2Status', label: 'Project 2 Status' },
    { key: 'projectTitle3', label: 'Project 3 Title' },
    { key: 'project3Status', label: 'Project 3 Status' },
    { key: 'staffRemarks', label: 'Staff Remarks' },
    { key: 'project1Score', label: 'Project 1 Score' },
    { key: 'project2Score', label: 'Project 2 Score' },
    { key: 'project3Score', label: 'Project 3 Score' },
    { key: 'communicationScore', label: 'Communication Score ' },
    { key: 'technicalScore', label: 'Technical Score ' },
    { key: 'noOfMocktest', label: 'No Of Mocktest ' },
    { key: 'mockTest1Score', label: 'Mock Test 1 Score' },
    { key: 'mockTest2Score', label: 'Mock Test 2 Score' },
    { key: 'mockTest3Score', label: 'Mock Test 3 Score' },
    { key: 'courseStartDate', label: 'Course Start Date' },
    { key: 'courseEndDate', label: 'Course End Date' },
    { key: 'placementneeded', label: 'Placement Needed' },
    { key: 'desiredlocation', label: 'Preferred Job Location' },

];

